<template>
    <div class="poi-layers">
        <header class="poi-layers__header">
            <div>
                <h1>POI-слои</h1>
                <p>Точки с радиусом и экраны, которые в них попадают.</p>
            </div>
            <a v-if="createUrl" :href="createUrl" class="btn btn--primary">Новый слой</a>
        </header>
        <p v-if="error" class="field__error">{{ error }}</p>
        <p v-else-if="loading">Загрузка…</p>
        <p v-else-if="layers.length === 0">Слоёв пока нет.</p>
        <table v-else class="poi-layers__table">
            <thead>
                <tr>
                    <th>Название</th>
                    <th>Экраны</th>
                    <th>Кампании</th>
                    <th>Владелец</th>
                    <th></th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="layer in layers" :key="layer.id">
                    <td><a :href="layer.urls.edit">{{ layer.name }}</a></td>
                    <td>{{ layer.screens }}</td>
                    <td>{{ layer.campaigns }}</td>
                    <td>{{ layer.owner || '—' }}</td>
                    <td class="poi-layers__actions">
                        <a :href="layer.urls.export">Excel</a>
                        <button v-if="layer.can_edit" type="button" class="btn btn--secondary btn--small" @click="remove(layer)">
                            Удалить
                        </button>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</template>

<script setup>
import { onMounted, ref } from 'vue';
import axios from 'axios';
import { confirmAction } from '../../../composables/useConfirm';

defineProps({
    createUrl: { type: String, default: '' },
});

const layers = ref([]);
const loading = ref(true);
const error = ref('');

const load = async () => {
    loading.value = true;
    error.value = '';
    try {
        const { data } = await axios.get('/rtb/poi-layers/data');
        layers.value = data.layers || [];
    } catch {
        error.value = 'Не удалось загрузить слои';
    } finally {
        loading.value = false;
    }
};

const remove = async (layer) => {
    const confirmed = await confirmAction({
        title: `Удалить слой «${layer.name}»?`,
        message: 'Уже созданные кампании останутся на своём снимке экранов. Новую кампанию по этому слою создать будет нельзя.',
        confirmLabel: 'Удалить',
        tone: 'danger',
    });
    if (!confirmed) return;
    await axios.delete(layer.urls.destroy);
    await load();
};

onMounted(load);
</script>

<style scoped lang="scss">
.poi-layers {
    margin: 0 auto;
    padding: 24px;
}

.poi-layers__header {
    display: flex;
    justify-content: space-between;
    gap: 16px;
    align-items: flex-start;
    margin-bottom: 16px;

    h1 {
        margin: 0 0 4px;
    }

    p {
        margin: 0;
        color: #6b7280;
    }
}

.poi-layers__table {
    width: 100%;
    border-collapse: collapse;
    background: #fff;

    th, td {
        padding: 10px 12px;
        border-bottom: 1px solid #e5e7eb;
        text-align: left;
    }
}

.poi-layers__actions {
    display: flex;
    gap: 12px;
    align-items: center;
}
</style>
